/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Collection List
 * OpenAPI spec version: 2.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from "@tanstack/react-query";

import type { GetListParams, List } from "./model";

import { mutator } from "./mutator/mutator";
import type { ErrorType } from "./mutator/mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getGetListUrl = (listId: string, params?: GetListParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/list/${listId}?${stringifiedParams}`
    : `/list/${listId}`;
};

/**
 * Get list with collections.
 */
export const getList = async (
  listId: string,
  params?: GetListParams,
  options?: Parameters<typeof mutator>[1]
): Promise<List> => {
  return mutator<List>(getGetListUrl(listId, params), {
    ...options,
    method: "GET"
  });
};

export const getGetListQueryKey = (listId: string, params?: GetListParams) => {
  return [`/list/${listId}`, ...(params ? [params] : [])] as const;
};

export const getGetListQueryOptions = <
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<void>
>(
  listId: string,
  params?: GetListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListQueryKey(listId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getList>>> = ({
    signal
  }) => getList(listId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: listId !== null && listId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getList>>
>;
export type GetListQueryError = ErrorType<void>;

export function useGetList<
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<void>
>(
  listId: string,
  params: undefined | GetListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getList>>,
          TError,
          Awaited<ReturnType<typeof getList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetList<
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<void>
>(
  listId: string,
  params?: GetListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getList>>,
          TError,
          Awaited<ReturnType<typeof getList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetList<
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<void>
>(
  listId: string,
  params?: GetListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetList<
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<void>
>(
  listId: string,
  params?: GetListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetListQueryOptions(listId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getHasItemUrl = (listId: string, itemId: string) => {
  return `/list/${listId}/${itemId}`;
};

/**
 * Check existence of a collection on a list. To check multiple collections in one request, see the collection_ids query parameter on /list/{listId}.
 */
export const hasItem = async (
  listId: string,
  itemId: string,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  return mutator<void>(getHasItemUrl(listId, itemId), {
    ...options,
    method: "HEAD"
  });
};

export const getHasItemMutationKey = () => ["hasItem"] as const;

export const getHasItemMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hasItem>>,
    TError,
    HasItemMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hasItem>>,
  TError,
  HasItemMutationVariables,
  TContext
> => {
  const mutationKey = getHasItemMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hasItem>>,
    HasItemMutationVariables
  > = (props) => {
    const { listId, itemId } = props ?? {};

    return hasItem(listId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HasItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof hasItem>>
>;

export type HasItemMutationError = ErrorType<void>;
export type HasItemMutationVariables = { listId: string; itemId: string };

export const useHasItem = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hasItem>>,
      TError,
      HasItemMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof hasItem>>,
  TError,
  HasItemMutationVariables,
  TContext
> => {
  return useMutation(getHasItemMutationOptions(options), queryClient);
};

export const getAddItemUrl = (listId: string, itemId: string) => {
  return `/list/${listId}/${itemId}`;
};

/**
 * Add collection to the the list.
 */
export const addItem = async (
  listId: string,
  itemId: string,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  return mutator<void>(getAddItemUrl(listId, itemId), {
    ...options,
    method: "PUT"
  });
};

export const getAddItemMutationKey = () => ["addItem"] as const;

export const getAddItemMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addItem>>,
    TError,
    AddItemMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addItem>>,
  TError,
  AddItemMutationVariables,
  TContext
> => {
  const mutationKey = getAddItemMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addItem>>,
    AddItemMutationVariables
  > = (props) => {
    const { listId, itemId } = props ?? {};

    return addItem(listId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof addItem>>
>;

export type AddItemMutationError = ErrorType<void>;
export type AddItemMutationVariables = { listId: string; itemId: string };

export const useAddItem = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addItem>>,
      TError,
      AddItemMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addItem>>,
  TError,
  AddItemMutationVariables,
  TContext
> => {
  return useMutation(getAddItemMutationOptions(options), queryClient);
};

export const getRemoveItemUrl = (listId: string, itemId: string) => {
  return `/list/${listId}/${itemId}`;
};

/**
 * Delete collection from list.
 */
export const removeItem = async (
  listId: string,
  itemId: string,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  return mutator<void>(getRemoveItemUrl(listId, itemId), {
    ...options,
    method: "DELETE"
  });
};

export const getRemoveItemMutationKey = () => ["removeItem"] as const;

export const getRemoveItemMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeItem>>,
    TError,
    RemoveItemMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeItem>>,
  TError,
  RemoveItemMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveItemMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeItem>>,
    RemoveItemMutationVariables
  > = (props) => {
    const { listId, itemId } = props ?? {};

    return removeItem(listId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeItem>>
>;

export type RemoveItemMutationError = ErrorType<void>;
export type RemoveItemMutationVariables = { listId: string; itemId: string };

export const useRemoveItem = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeItem>>,
      TError,
      RemoveItemMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof removeItem>>,
  TError,
  RemoveItemMutationVariables,
  TContext
> => {
  return useMutation(getRemoveItemMutationOptions(options), queryClient);
};
